import MainInformationTypes from 'Containers/MainInformations/types'

// Reset Page Edition to false 
export const resetPageUnderEdition = () => ({
  type: MainInformationTypes.RESET_PAGE_EDITION,
})

// Set Page Edition
export const setPageUnderEdition = (payload) => ({
  type: MainInformationTypes.SET_PAGE_EDITION,
  payload,
})

export function checkPasswordAction(payload) {
  return {
    type: MainInformationTypes.CHECK_PASSWORD,
    payload,
  }
}

export function setCheckPasswordResultAction(payload) {
  return {
    type: MainInformationTypes.SET_CHECK_PASSWORD_RESULT,
    payload,
  }
}

export function setPasswordIsCheckedAction(payload) {
  return {
    type: MainInformationTypes.SET_PASSWORD_IS_CHECKED,
    payload,
  }
}

export function changeWidgetConditionEditionStatusAction(payload) {
  return {
    type: MainInformationTypes.CHANGE_WIDGET_CONDITION_EDITION_STATUS,
    payload,
  }
}

export const resetControlUnderEditionAction = () => ({
  type: MainInformationTypes.RESET_CONTROL_EDITION,
})

// Set Page Edition
export const setControlUnderEditionAction = (payload) => ({
  type: MainInformationTypes.SET_CONTROL_EDITION,
})

